import styled from 'styled-components';

export const HomeStyles = styled.div`
  margin-top: 16px;
`